import script from "./CasinoLivePage.vue?vue&type=script&setup=true&lang=ts"
export * from "./CasinoLivePage.vue?vue&type=script&setup=true&lang=ts"

import "./CasinoLivePage.vue?vue&type=style&index=0&id=baa35e68&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-baa35e68"]])

export default __exports__